import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {get, isEmpty} from 'lodash'
import {recordDisplay} from 'utils'
import styles from 'employees/Invite.scss'
import {actionCreators} from 'actions'
import api from 'api'
import {getGroups} from 'employees/form/EmploymentInfomation'
import Button from 'jbc-front/components/Button'
import {getState} from 'utils'
import {getCurrentQueryFromLocation, fetchEmployees, getSavedDisplayEmployeeLimit} from 'employees/list/utils'
import PaginatorWithResult from 'employees/list/PaginatorWithResult'
import SearchForm from 'employees/list/SearchForm'
import SortableTh from 'employees/list/SortableTh'
import {Hint} from 'employees/Invite'
import {TextField} from 'jbc-front/components/Form'
import {getFormValues, reduxForm} from 'redux-form'
import {staffCode} from 'validators'
import Modal from 'jbc-front/components/CommonModal'
import {Redirect, useHistory, useLocation} from 'react-router-dom'
import {asyncError} from 'store/actions/asyncError'
import {Hamburger} from 'jbc-front/components/icons'
import menuStyles from './CoordinationTargets.scss'
import {convertFormToQuery, formName as employeeSearchFormName} from 'employees/list/utils'

export const invitationStatuses = {
  not_invited: '未招待',
  invited: '招待済み',
  registered: '登録済み',
  only_enrollment_input: '未招待',
}

const StaffCodeForm = reduxForm({
  form: 'stuffCodeInput',
  enableReinitialize: true,
  onSubmit: async (values, dispatch, {employeeId, hideModal}) => {
    const {
      auth: {token},
    } = await getState(dispatch)
    try {
      await api.createWithAuth(token).employees.update(employeeId, values)
      hideModal(true)
    } catch (err) {
      dispatch(asyncError(err))
    }
  },
})(({handleSubmit, name, hideModal, submitting}) => (
  <React.Fragment>
    <Modal.Header hideModal={hideModal}>スタッフコードの登録</Modal.Header>
    <Modal.Body>
      <form onSubmit={handleSubmit}>
        <div className="form_box_main">
          <TextField name="staff_code" label={`${name}さんのスタッフコード`} validate={staffCode} />
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <Modal.Buttons>
        <Button onClick={hideModal}>キャンセル</Button>
        <Button primary onClick={handleSubmit} disabled={submitting}>
          保存
        </Button>
      </Modal.Buttons>
    </Modal.Footer>
  </React.Fragment>
))

export const StaffModal = ({isOpen, hideModal, ...rest}) => (
  <Modal isOpen={isOpen} hideModal={hideModal}>
    <StaffCodeForm hideModal={hideModal} {...rest} />
  </Modal>
)

export const SelectAllPagesMenu = ({hide, onSelectAllPages, triggerRef}) => {
  const menuRef = useRef(null)

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (!menuRef.current || menuRef.current.contains(event.target) || triggerRef.current?.contains(event.target)) {
        return
      }

      hide()
    }

    document.addEventListener('mousedown', handleDocumentClick)
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick)
    }
  }, [hide, triggerRef])

  return (
    <div ref={menuRef} className={menuStyles.baloonWrap}>
      <div className={menuStyles.baloon}>
        <ul className={menuStyles.links}>
          <li>
            <a
              onClick={() => {
                onSelectAllPages(true)
                hide()
              }}
            >
              全ページの従業員を選択
            </a>
          </li>
          <li>
            <a
              onClick={() => {
                onSelectAllPages(false)
                hide()
              }}
            >
              全ページの従業員を解除
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

const Row = ({employee, selected, disabledMessage, onClick, onInputClick}) => {
  const [showHint, setShowHint] = useState(false)
  const [hint, setHint] = useState(null)

  const handleClick = () => {
    if (disabledMessage) {
      setShowHint(true)
      setHint(disabledMessage)
    } else {
      onClick(employee)
    }
  }

  const handleInputClick = (e) => {
    e.stopPropagation()
    onInputClick(employee.id, employee.display_last_name, {staff_code: employee.staff_code})
  }

  const selectedClass = selected ? 'm-table-checkbox-on' : 'm-table-checkbox-off'
  const disabledClass = disabledMessage ? ' u-cur-notallowed' : ' u-cur-pointer'

  return (
    <tr>
      <td onClickCapture={handleClick} className={selectedClass + disabledClass}>
        {showHint && <Hint onClick={() => setShowHint(false)}>{hint}</Hint>}
        <input
          type="checkbox"
          checked={selected}
          className={disabledClass ? 'u-cur-notallowed' : 'u-cur-pointer'}
          readOnly
        />
      </td>
      <td className={styles.staffcodeColumn} onClick={handleInputClick}>
        <a className="u-txt-link">{employee.staff_code || '未入力'}</a>
      </td>
      <td className={styles.nameColumn}>{recordDisplay.fullName(employee)}</td>
      <td className={styles.employmentStatusColumn}>
        {recordDisplay(get(employee, 'personnel_history.employment_type_name'))}
      </td>
      <td className={styles.groupColumn}>
        {recordDisplay(
          !isEmpty(getGroups(employee)) &&
            getGroups(employee).map((group, index) => (
              <span key={index}>
                {group}
                <br />
              </span>
            ))
        )}
      </td>
      <td className={styles.positionColumn}>{recordDisplay(get(employee, 'personnel_history.position_name'))}</td>
      <td className={styles.dateColumn}>
        {recordDisplay(employee.joined_at && employee.joined_at.replace(/-/g, '/'))}
      </td>
    </tr>
  )
}

const selectByAll = (employee) => !!employee.staff_code

const isSelected = (employee, selected, selectedAllPage = null) =>
  employee.staff_code &&
  (selected[employee.id] === undefined
    ? selectedAllPage === null
      ? employee.syncs_with_payroll
      : selectedAllPage
    : selected[employee.id])

const isAllSelected = (employees, selected, selectedAllPage = null) =>
  employees.some((employee) => isSelected(employee, selected, selectedAllPage)) &&
  employees.every((employee) => isSelected(employee, selected, selectedAllPage) || !selectByAll(employee))

const additionalParams = {embed: ['personnel_history']}

const List = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const employees = useSelector((state) => state.employees.list.data)
  const token = useSelector((state) => state.auth.token)
  const selected = useSelector((state) => state.employees.selected)
  const user = useSelector((state) => state.session.currentUser)
  const client = useSelector((state) => state.client.current)
  const employeeSearchFormValues = useSelector((state) => getFormValues(employeeSearchFormName)(state))

  const [employeeId, setEmployeeId] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const [name, setName] = useState('')
  const [initialValues, setInitialValues] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const [selectedAllPage, setSelectedAllPage] = useState(null)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuTriggerRef = useRef(null)

  useEffect(() => {
    dispatch(actionCreators.employees.clearSelected())

    return () => {
      dispatch(actionCreators.employees.clearSelected())
    }
  }, [dispatch])

  const handleRowClick = (employee) => {
    dispatch(
      actionCreators.employees.changeMulti([
        {
          [employee.id]: !isSelected(employee, selected, selectedAllPage),
        },
      ])
    )
  }

  const saveTargets = async () => {
    try {
      setSubmitting(true)
      await api.createWithAuth(token).employees.payroll.updateTargets({
        selected,
        selected_all_page: selectedAllPage,
        search_params: {
          ...getCurrentQueryFromLocation(location, user),
          ...convertFormToQuery(employeeSearchFormValues),
        },
      })
      history.push('/employees')
    } catch (err) {
      dispatch(asyncError(err))
      setSubmitting(false)
    }
  }

  const disabledMessage = (employee) => {
    if (!employee.staff_code) {
      return 'スタッフコードを入力してください'
    }
    return null
  }

  const handleSelectAllClick = () => {
    const allSelected = isAllSelected(employees, selected, selectedAllPage)
    if (allSelected) {
      dispatch(
        actionCreators.employees.changeMulti(
          employees
            .filter((employee) => isSelected(employee, selected, selectedAllPage))
            .map((employee) => ({[employee.id]: false}))
        )
      )
    } else {
      dispatch(
        actionCreators.employees.changeMulti(
          employees
            .filter(selectByAll)
            .filter((employee) => !isSelected(employee, selected, selectedAllPage))
            .map((employee) => ({[employee.id]: true}))
        )
      )
    }
  }

  const handleSelectAllPages = (value) => {
    setSelectedAllPage(value)
    setIsMenuOpen(false)
    dispatch(actionCreators.employees.clearSelected())
  }

  const hideMenu = () => {
    setIsMenuOpen(false)
  }

  const hideModal = (loadData = false) => {
    setIsOpen(false)
    if (loadData) {
      dispatch(fetchEmployees(getCurrentQueryFromLocation(location, user), additionalParams))
    }
  }

  const handleInputClick = (nextEmployeeId, nextName, nextInitialValues = {}) => {
    setEmployeeId(nextEmployeeId)
    setIsOpen(true)
    setName(nextName)
    setInitialValues(nextInitialValues)
  }

  const allSelected = isAllSelected(employees, selected, selectedAllPage)
  const allClickClass = allSelected ? 'm-table-checkbox-on' : 'm-table-checkbox-off'

  return (
    <div>
      {client.plan_type === 'free_plan' && <Redirect to="/employees" />}
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">従業員の給与連携設定</h1>
        <p className="m-title-main-note">
          ジョブカン給与計算と連携する従業員を設定します。
          <br />
          設定しないとジョブカン給与計算と情報を連携されません。
        </p>
      </div>
      <div className="l-contents-wrap">
        <div className="l-wrap-xl">
          <SearchForm additionalParams={additionalParams} />

          <div className="l-overflow-scroll">
            <table className="m-table-list m-table-fixed">
              <thead>
                <tr>
                  <th className="m-table-list-check">
                    <div className={menuStyles.wrap} onClick={(e) => e.stopPropagation()}>
                      <div
                        onClick={handleSelectAllClick}
                        className={allClickClass + ' u-cur-pointer'}
                        role="checkbox"
                        aria-checked={allSelected}
                        tabIndex={-1}
                      >
                        <input type="checkbox" readOnly checked={allSelected} />
                      </div>
                      <div ref={menuTriggerRef} className={menuStyles.button}>
                        <Hamburger
                          size={12}
                          className={`${menuStyles.menu} ${isMenuOpen ? 'ignore-react-onclickoutside' : ''}`}
                          onClick={() => setIsMenuOpen((prevState) => !prevState)}
                        />
                        {isMenuOpen && (
                          <SelectAllPagesMenu
                            hide={hideMenu}
                            onSelectAllPages={handleSelectAllPages}
                            triggerRef={menuTriggerRef}
                          />
                        )}
                      </div>
                    </div>
                  </th>
                  <SortableTh field="staff_code" globalClassName={styles.staffcodeColumn}>
                    スタッフコード
                  </SortableTh>
                  <SortableTh field="full_name_kana" globalClassName={styles.nameColumn}>
                    氏名
                  </SortableTh>
                  <SortableTh field="employment_type" globalClassName={styles.employmentStatusColumn}>
                    雇用形態
                  </SortableTh>
                  <SortableTh field="group" globalClassName={styles.groupColumn}>
                    グループ
                  </SortableTh>
                  <SortableTh field="position" globalClassName={styles.positionColumn}>
                    役職
                  </SortableTh>
                  <SortableTh field="joined_at" globalClassName={styles.dateColumn}>
                    入社日
                  </SortableTh>
                </tr>
              </thead>
              <tbody>
                {employees.map((employee) => (
                  <Row
                    key={employee.id}
                    employee={employee}
                    onClick={handleRowClick}
                    onInputClick={handleInputClick}
                    selected={isSelected(employee, selected, selectedAllPage)}
                    disabledMessage={disabledMessage(employee)}
                  />
                ))}
              </tbody>
            </table>
          </div>
          <PaginatorWithResult limit={getSavedDisplayEmployeeLimit(location.pathname, user)} />
        </div>
        <div className="u-mt20 u-ta-c">
          <Button
            primary
            onClick={saveTargets}
            disabled={submitting || (isEmpty(selected) && selectedAllPage === null)}
          >
            対象者を保存する
          </Button>
        </div>
        <StaffModal
          hideModal={hideModal}
          isOpen={isOpen}
          employeeId={employeeId}
          name={name}
          initialValues={initialValues}
          submitting={submitting}
        />
      </div>
    </div>
  )
}

export default List
